import React, { useRef, useEffect } from 'react';
import { useTicketDetails } from '../../../pages/Tickets/context/TicketDetailsProvider';
import TicketResponse from './TicketResponse/TicketResponse';

import './TicketResponseList.scss';

export default function TicketResponseList() {
  const { ticketResponseListing } = useTicketDetails();
  const chatRef = useRef(null);
  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, [ticketResponseListing]);

  return (
    <div className="ticket-reponse-list-container" ref={chatRef}>
      {ticketResponseListing?.map(item => (
        <TicketResponse key={item?.TicketResponseId} ticketResponse={item} />
      ))}
    </div>
  );
}
